export enum ClientActiveStatus {
    INACTIVE = 0,
    ACTIVE = 1,
    UNKNOWN = 2
}



// WEBPACK FOOTER //
// ./src/types/enums/ClientActiveStatus.ts